import { render, staticRenderFns } from "./NavigationButtons.vue?vue&type=template&id=fcd77314&"
import script from "./NavigationButtons.vue?vue&type=script&lang=js&"
export * from "./NavigationButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports